<template lang="html">
  <div>
    <div class="user__details">
      <div class="user__skills">
        <!-- <div class="skills__item skills__item--active">Soccer</div> -->
        <div class="skills__item" v-for="skill in skills" :key="skill.skill_id">
          {{ skill.skill_name }}
        </div>
      </div>

      <v-container class="user__tasks">
        <div class="user__task" v-for="completion in completions">
          <div class="task__meta">
            <div class="task__date">{{ completionTime(completion.completion_finished) }}</div>
            <div class="task__ratings" v-for="rating in calculateRating(completion.completion_rating)">
              <v-icon small>star</v-icon>
            </div>
          </div>
          <router-link class="task__title" :to="{ name: 'TaskDetails', params: {id: completion.task_id} }">
            {{ completion.task_name }}
          </router-link>
          <router-link class="task__project" :to="{ name: 'ProjectOverview', params: {id: completion.project_id}}" v-if="completion.project_id">
            {{ completion.project_name }}
          </router-link>
          <div class="task__description" v-if="completion.completion_rating_comment">
            {{ completion.completion_rating_comment }}
          </div>
          <div class="task__actions">
            <router-link class="task__completion-link" :to="{name: 'TaskCompletionDetails', params: {id: completion.completion_id}}">
              View Details
            </router-link>
          </div>
        </div>
      </v-container>
    </div>

    <div v-if="noCompletions">
      <no-data-message v-if="isMyself">
        <v-icon slot="icon">person</v-icon>
        <div slot="message">
          There are no completions to show
        </div>
        <div slot="sub-message">
          You have no completions yet. Try exploring some effort?
        </div>
        <div slot="button">
          <router-link :to="{name: 'Tasks', query: { browse_id: 1 }}">
            Find Effort
          </router-link>
        </div>
      </no-data-message>
      <no-data-message v-else>
        <v-icon slot="icon">person</v-icon>
        <div slot="message">
          There are no completions to show
        </div>
        <div slot="sub-message">
          There are no completions to show. This user did not complete any effort yet.
        </div>
      </no-data-message>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get';
import moment from 'moment';

export default {
  props: {
    profile: Object,
  },
  computed: {
    completions() {
      return get(this.profile, 'completion_data', []);
    },
    noCompletions() {
      return this.completions.length === 0;
    },
    id() {
      return get(this.profile, 'user_data.user_id');
    },
    skills() {
      return get(this.profile, 'users_skills');
    },
    userId() {
      return this.$route.params.id || this.$store.getters['auth/userId'];
    },
    isMyself() {
      return this.userId === this.$store.getters['auth/userId'];
    },
  },
  methods: {
    calculateRating(rating) {
      const karma = parseInt((rating || 0), 10);
      return Math.min(karma, 5);
    },
    completionTime(value) {
      return moment(value).fromNow();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";

.user__skills {
  display: flex;
  direction: column;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 15px;
}

.skills__item {
  width: fit-content;
  height: fit-content;
  color: $blue;
  font-weight: 400;
  border: 1px solid $blue;
  padding: 3px 14px;
  border-radius: 24px;
  cursor: pointer;
  margin: 5px;
}

.skills__item--active {
  font-weight: 500;
  color: white;
  background: $blue;
}

.user__task {
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid $lighter;
}

.user__task:first-child {
  padding-top: none;
}

.user__task:last-child {
  border-bottom: none;
}

.task__meta {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 3px;
}

.task__meta .task__date {
  font-size: 13px;
  color: #b2bac2;
  margin-right: 15px;
}

.task__title {
  color: $blue;
  font-size: 16px;
  line-height: 22px;
  // margin-bottom: 10px;
  cursor: pointer;
  text-decoration: none;
}

.task__actions {
  margin-top: 5px;
  display: flex;
  justify-content: flex-end;
}

.task__description {
  color: #161718;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 10px;
}

.task__project {
  color: $blue;
  font-size: 13px;
  line-height: 16px;
  cursor: pointer;
  text-decoration: none;
  margin-top: 5px;
  display: block;
}

.task__completion-link {
  text-decoration: none;
  color: $blue;
}
</style>



// WEBPACK FOOTER //
// src/components/UserProfile.vue